import { Component, Input, OnInit } from '@angular/core';
import { LoadConfigService } from '../../services/load-config.service';
import { ArchiveDNSResultsService } from '../../services/archive-dns-results.service';
import { StudyNavigationService } from '../../services/study-navigation.service';
import { InstructionService } from '../../services/instruction.service';

@Component({
  selector: 'app-consent-form',
  templateUrl: './consent-form.component.html',
  styleUrls: ['./consent-form.component.scss'],
})
export class ConsentFormComponent implements OnInit {
  @Input('route') route;
  continueButtonLabel: string;
  content: { title: string; body: string };

  constructor(
    private saveResult: ArchiveDNSResultsService,
    private navigationService: StudyNavigationService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    this.content = this.instructionService.getInstructions('EN')['consent'];
    this.continueButtonLabel = this.instructionService.getTranslationsForTerm(
      'CONSENT_FORM_BUTTON'
    );
  }

  onSubmit() {
    this.saveResult.saveConsent();
    this.navigationService.renderNext();
  }
}
